module.exports = __webpack_public_path__ + "images/emoji/ru.bd1e4563a72cad664c9e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ru.png
// module id = 4wqJ
// module chunks = 13